import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Text, Paragraph } from 'components/core/Typography';

import './ScarcityBanner.scss';

export default function ScarcityBanner({ backgroundColor }) {
	return (
		<div className="scarcity-banner">
			<div className={classnames('banner-content', backgroundColor)}>
				<Text
					size="medium"
					color="white"
				>
					Reserve Now!
				</Text>{' '}
				<Paragraph
					color="white"
					className="scarcity-text"
					last
				>
					Pricing and availability may change.
				</Paragraph>
			</div>
		</div>
	);
}

ScarcityBanner.propTypes = {
	backgroundColor: PropTypes.oneOf(['red', 'secondaryBlue', 'priceBlue']),
};

ScarcityBanner.defaultProps = {
	backgroundColor: 'red',
};
